export const required = (value: string) =>
  (value != null || value != undefined) &&
  value.toString().length > 0 ? undefined : (
    "Obrigatório"
  );
